
/// <reference path="../../meevoStore.module.ts" />
module Meevo.Plugins.MeevoStore {

    class ModalInfoController {

        static $inject = [
            '$filter',
            '$mdDialog',
            '$translate',
            'meevo.plugins.meevoStore.MeevoStoreService',
            'modalTitle',
            'modalText',
            'canProcess',
            'canRemove',
            'pendingText',
            'isProcess',
            'module',
        ];
        public isAgreeTerms: boolean = false;

        public documentTerms: IMeevoStoreDocumentPolicy;
        public documentPolicy: IMeevoStoreDocumentPolicy;
        public documentAdjustment: IMeevoStoreDocumentPolicy;
        public processPendoClasses: { [key in keyof typeof Meevo.Model.ModuleEnum]?: string } = {
            [Meevo.Model.ModuleEnum.TwoWaySMS]: 'twowaysms-xchange-process-pendo'
        }

        public get moduleId(): Meevo.Model.ModuleEnum {
            return this.module.moduleId;
        }

        public get price(): number {
            return this.module.price;
        }

        constructor(
            protected $filter: angular.IFilterService,
            protected $mdDialog: angular.material.IDialogService,
            protected $translate: angular.translate.ITranslateService,
            protected storeService: Meevo.Plugins.MeevoStore.IMeevoStoreService,
            public modalTitle: string,
            public modalText: any,
            public canProcess: boolean,
            public canRemove: boolean,
            public pendingText: string,
            public isProcess: boolean,
            public module: IMeevoStoreModuleType
        ) {

            this.storeService.getTerms(ModuleDocumentsTypeEnum.ModuleTermsAndConditions, module.moduleId).then((data) => {
                this.documentTerms = data;
            });
            this.storeService.getTerms(ModuleDocumentsTypeEnum.ModulePrivacyPolicy, module.moduleId).then((data) => {
                this.documentPolicy = data;
            });
            this.storeService.getTerms(SystemDocumentsTypeEnum.MeevoStoreAdjustment).then((data) => {
                this.documentAdjustment = data;
            });
        }

        apply() {
            this.$mdDialog.hide({
                status: true,
                canProcess: this.canProcess,
                canRemove: this.canRemove,
            });
        }

        cancel() {
            this.$mdDialog.hide({ status: false });
        }

        openTerms(documentsText: string, modalTitle: string = 'LABEL_TERMS_OF_SERVICE') {
            this.storeService.openTermsModal(this.documentTerms.documentsText, modalTitle);
        }

        get hidePrice(): boolean {
            const isEgift = this.moduleId === this.moduleEnum.eGift;

            return isEgift || (this.module.hidePrice === true && this.module.price === 0);
        }

        get moduleEnum(): any {
            return Meevo.Model.ModuleEnum;
        }

        public handleOpenLink() {
            if ([
                Meevo.Model.ModuleEnum.CardConnect,
                Meevo.Model.ModuleEnum.Worldpay,
                Meevo.Model.ModuleEnum.VanguardID,
                Meevo.Model.ModuleEnum.SalonCloudsPlusECommerce,
                Meevo.Model.ModuleEnum.SalonCloudsPlusTele,
                Meevo.Model.ModuleEnum.SalonCloudsPlusSnapSMSTexting,
                Meevo.Model.ModuleEnum.SnapLiteBySalonCloudsPlus,
                Meevo.Model.ModuleEnum.SalonClouds,
                Meevo.Model.ModuleEnum.Vish,
                Meevo.Model.ModuleEnum.SalonCloudsMarketing,
                Meevo.Model.ModuleEnum.AfterPose,
                Meevo.Model.ModuleEnum.Concerto,
                Meevo.Model.ModuleEnum.Flossie,
                Meevo.Model.ModuleEnum.Mya,
                Meevo.Model.ModuleEnum.BookingBee,
                Meevo.Model.ModuleEnum.MyAdvice,
                Meevo.Model.ModuleEnum.Edge,
                Meevo.Model.ModuleEnum.Glammatic,

            ].indexOf(this.moduleId) !== -1) {
                this.storeService.sendEmailNotification(this.moduleId, this.module.moduleTypeEnum).then(() => {
                    this.storeService.openMessageModal('TEXT_INQUIRY_HAS_BEEN_SENT');
                });
            }
        }
    }

    angular.module('meevo.plugins.meevoStore')
        .controller('meevo.plugins.meevoStore.ModalInfoController', ModalInfoController);
}
